/* eslint-disable */
import styles from './style.module.scss';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import { t } from '@web-solutions/module-localization';
import { useNav } from 'src/onboarding/hooks/nav';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import Analytics from '@web-solutions/module-analytics';
import { useStore } from 'src/onboarding/store/store';

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();

  const gender = useStore((state) => state.gender);
  const isMale = gender === 'Male';

  return (
    <div
      className={styles.page}
      style={isMale ? { paddingBottom: '670px' } : { paddingBottom: '0px' }}
    >
      {currentIndex !== 0 && (
        <div className={styles.back} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={styles.container}>
        <div className={styles.wrapperInfo}>
          <Title className={styles.title}>{t('onboarding.trusted.title')}</Title>
          <Text semibold className={styles.description}>
            {t('onboarding.trusted.description')}
          </Text>
        </div>
        <div className={isMale ? styles.imageContainerMen : styles.imageContainer}></div>{' '}
      </div>

      <div className={styles.continue}>
        <div className={styles.blur}></div>
        <Button
          onClick={() => {
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'trusted-2',
            });
            onNext();
          }}
          title={t('onboarding.trusted.continue')}
        />
      </div>
    </div>
  );
}

export default Page;
